const DesignBuildContent = {
	meta: "Design & prototyping",
	id01: "CardDesign",
	id02: "TemplateDesign",
	titleCard: "Design variations for the search result card",
	parasCard: [
		"I rapidly explored options for information architecture in the low resolution wireframing stage. I had to work with existing APIs while exploring better future solutions.",
		"At this point, I switched to exploring higher resolution designs that would both integrate with the dated website while introducing real progress.",
		"Once the team agreed on a design, I built the component to be fully responsive using semantic HTML and CSS.",
	],
	img01alt: "Search card design",
	captions01: [
		"Cleaner, clearer 3 column layout achieved with white space and harmonised typography",
		"Information architecture based on user research regarding top questions, info needed at this point",
		"Lead-in price and featured promotion",
	],
	img02alt: "Search card design",
	captions02: [
		"Promotional banners unique to each card",
		"Itinerary listed in clearer sequence and format",
		"Pricing block given greater focus",
	],
	img03alt: "Search card design",
	captions03: [
		"Clearer grid that improves information grouping and overall aesthetic",
		"Instead of ship images, we explored dynamic map generation of itinerary",
	],
	img04alt: "Search card design",
	captions04: [
		"Section divides to allow for easier scanning of search results",
	],
	img05alt: "Search card design",
	captions05: [
		"Social proofing, showing most popular, most viewed, top seller etc",
		"Greater space alloted for included promotions",
		"Comparitive pricing at a glance for cabin options",
	],
	titleTemplate: "UX for the search results template",
	parasTemplate: [
		"The Product team decided on Algolia Instant Search as the software that would help us make a giant leap forward in search UX.",
		"I developed prototypes directly in the browser so we could fully test UX ideas using Algolia IS features. At the same time I progressed the design to reach a production-ready template. I then collaborated with software engineers to integrate this new view with the controllers and model.",
	],
	imgTemplateAlt: "Layout of new dynamic search template",
	captionsTemplate: [
		"Extended search form; users are inbound from search engine or marketing link; form pre-populated with desirable options ",
		"Dynamic facet filtering, immediately refreshes results",
		"User-selected options to build and refine search much easier",
		"Control order of search results",
		"A count of available products which immediately updates with each option user selects",
	],
};

export default DesignBuildContent;
